<template>
  <div class="admin-layout">
    <aside class="admin-sidebar">
      <div class="admin-brand">
        <strong>STRONGOVA</strong>
        <span>后台管理 Admin Panel</span>
      </div>

      <el-menu
        :default-active="activeMenu"
        background-color="#171411"
        text-color="rgba(245,243,239,0.72)"
        active-text-color="#f5f3ef"
        class="admin-menu"
        router
      >
        <el-menu-item index="/dashboard">仪表盘 Dashboard</el-menu-item>
        <el-menu-item index="/products">产品 Products</el-menu-item>
        <el-menu-item index="/categories">分类 Categories</el-menu-item>
        <el-menu-item index="/page-sections">页面内容 Page Sections</el-menu-item>
        <el-menu-item index="/cases">案例 Cases</el-menu-item>
        <el-menu-item index="/articles">文章 Articles</el-menu-item>
        <el-menu-item index="/inquiries">询盘 Inquiries</el-menu-item>
        <el-menu-item index="/custom-requests">定制请求 Custom Requests</el-menu-item>
        <el-menu-item index="/media">媒体库 Media</el-menu-item>
        <el-menu-item index="/settings">站点设置 Settings</el-menu-item>
      </el-menu>
    </aside>

    <div class="admin-main">
      <header class="admin-topbar">
        <div>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>
        <div class="admin-topbar__actions">
          <div class="admin-user">
            <span>{{ admin.username || 'admin' }}</span>
            <small>{{ admin.role || 'admin' }}</small>
          </div>
          <el-button size="small" @click="logout">退出登录 Log out</el-button>
        </div>
      </header>

      <main class="admin-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { clearSession, getAdminProfile } from '../utils/auth'

export default {
  name: 'AdminLayout',
  data () {
    return {
      admin: getAdminProfile()
    }
  },
  computed: {
    activeMenu () {
      return this.$route.path
    },
    pageTitle () {
      return this.$route.meta.title || 'Admin'
    },
    pageSubtitle () {
      const map = {
        dashboard: '查看当前内容系统状态与下一步工作重点。',
        products: '维护官网使用的产品数据、图片与结构内容。',
        categories: '管理产品分类与颜色分组逻辑，颜色系列使用类型为 Colour 的分类。',
        pageSections: '维护页面描述、主图和图片组内容。',
        cases: '维护项目案例、图库与国家信息。',
        articles: '维护知识文章与新闻内容。',
        inquiries: '查看网站联系表单提交的询盘。',
        customRequests: '查看来自定制页面的请求。',
        media: '集中管理可复用的图片、视频和文件。',
        settings: '维护全局联系方式与站点级配置。'
      }
      return map[this.$route.meta.menu] || '管理 Strongova 官网内容。'
    }
  },
  methods: {
    logout () {
      clearSession()
      this.$router.push('/login')
    }
  }
}
</script>

<style>
.admin-layout {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  min-height: 100vh;
}

.admin-sidebar {
  display: flex;
  flex-direction: column;
  background: var(--sidebar);
  color: #f5f3ef;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.admin-brand {
  padding: 28px 24px 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.admin-brand strong,
.admin-brand span {
  display: block;
}

.admin-brand strong {
  font-size: 20px;
  letter-spacing: 0.08em;
}

.admin-brand span {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(245, 243, 239, 0.58);
  text-transform: uppercase;
  letter-spacing: 0.14em;
}

.admin-menu {
  border-right: 0;
  flex: 1;
}

.admin-menu .el-menu-item {
  height: 48px;
  line-height: 48px;
}

.admin-main {
  min-width: 0;
}

.admin-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 28px 32px 18px;
}

.admin-topbar h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 500;
}

.admin-topbar p {
  margin: 8px 0 0;
  color: var(--muted);
  line-height: 1.6;
}

.admin-topbar__actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.admin-user {
  text-align: right;
}

.admin-user span,
.admin-user small {
  display: block;
}

.admin-user small {
  margin-top: 4px;
  color: var(--muted);
  text-transform: capitalize;
}

.admin-content {
  padding: 0 32px 32px;
}

@media (max-width: 960px) {
  .admin-layout {
    grid-template-columns: 1fr;
  }

  .admin-sidebar {
    display: none;
  }

  .admin-topbar,
  .admin-content {
    padding-left: 20px;
    padding-right: 20px;
  }

  .admin-topbar {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
